export const TAG_LIST = [
  "필터태그1",
  "필터태그2",
  "필터태그3",
  "소고기",
  "국내산",
  "베스트",
  "베나라",
  "베베",
  "한우",
  "구이용",
  "요리용",
  "구이용 조미료",
  "요리용 조미료",
  "베이비로인",
  "돼지고기",
  "피그로인",
  "세트상품",
  "선물용",
  "캠핑팩",
  "밀키트",
  "스테이크",
  "꼬리",
  "안심",
  "등심",
  "갈비",
  "바비큐",
  "T본",
];
